import { render } from "./BecomeSeller.vue?vue&type=template&id=1ede63c1&scoped=true"
import script from "./BecomeSeller.vue?vue&type=script&lang=js"
export * from "./BecomeSeller.vue?vue&type=script&lang=js"

import "./custom-become-seller.scss?vue&type=style&index=0&id=1ede63c1&lang=scss&scoped=true"
import "./BecomeSeller.vue?vue&type=style&index=1&id=1ede63c1&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ede63c1"]])

export default __exports__